import { render, staticRenderFns } from "./MaintenanceNotice.vue?vue&type=template&id=59ce327c&scoped=true&"
import script from "./MaintenanceNotice.vue?vue&type=script&lang=js&"
export * from "./MaintenanceNotice.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceNotice.vue?vue&type=style&index=0&id=59ce327c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ce327c",
  null
  
)

/* custom blocks */
import block0 from "./MaintenanceNotice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports